import React from 'react';
import { FormInput, ReadOnly } from 'lqx-react';
import { Flex } from 'lqx-react/src';
import { Linked } from '@type-r/models';
import { useLinked } from '@type-r/react';
import AddCircle from '@material-ui/icons/AddCircle';
import DeleteForever from '@material-ui/icons/DeleteForever';
import { IconButton, makeStyles } from '@material-ui/core';

export const MultiItemInput = ({ $items, label = '', trailingCharsCount }: { $items: Linked<string[]>, label?: string, trailingCharsCount? : number }) => {
    return (<>
        <AddItemsInput $items={$items} label={label}/>
        {
            $items.map(($item) => {
                return <ItemRow $item={$item} trailingCharsCount={trailingCharsCount}/>
            })
        }
    </>)
};

const AddItemsInput = ({ $items, label = '' }: { $items: Linked<string[]>, label?: string }) => {
    const $value = useLinked('');
    const classes = buttonStyles();
    const readOnly = React.useContext( ReadOnly );

    const addItem = () => { 
        $items.push($value.value); 
        $value.set(''); 
    }

    return (<Flex row className={classes.container}>
        <FormInput label={label} $value={$value} />
        <IconButton aria-label="Add" onClick = { addItem } className={ classes.addIcon } disabled={!$value.value || readOnly}>
            <AddCircle fontSize="large"/>
        </IconButton>
    </Flex>);
};

const ItemRow = ({ $item, trailingCharsCount }) => {
    const classes = buttonStyles();
    const readOnly = React.useContext( ReadOnly );
    let obfuscatedItem = $item.value;

    if(trailingCharsCount && $item.value.length > trailingCharsCount)
    {
        obfuscatedItem = new Array(obfuscatedItem.length - trailingCharsCount + 1).join('x') + obfuscatedItem.slice(-trailingCharsCount);
    }

    return (
        <div>
            <span>{obfuscatedItem}</span>
            <IconButton aria-label="Remove" onClick={ () => $item.remove() } className={ classes.removeIcon } disabled={readOnly} >
                <DeleteForever fontSize="large"/>
            </IconButton>
        </div>        
    );
};

const styleBase = {
    actionButton: {
        height:30
    }
};

const buttonStyles = makeStyles({    
    addIcon: {
        ...styleBase.actionButton,
        color:"green"
    },
    removeIcon: {
        ...styleBase.actionButton,
        color:"red"
    },
    container: {
        alignItems:"flex-start"
    }
})